<template>
  <div>
    <el-steps :active="fixedStepIndex" align-center>
      <el-step
        v-for="(step, index) in steps"
        :status="stepStatus(index, steps)"
        :title="step.title"
        :key="step.title"
        @click.native="() => handleStepClick(index)">
      </el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  props: ['fixedStepIndex', 'currentStepIndex', 'steps'],
  methods: {
    stepStatus(stepIndex, steps) {
      const lastStepIndex = steps.length - 1

      // 当前步骤
      if (stepIndex === this.currentStepIndex) {
        // 当前步骤 && 是最新步骤
        if (stepIndex === this.fixedStepIndex) {
          // 当前步骤 && 是最新步骤 && 是最后一步
          if (stepIndex === lastStepIndex) {
            return 'process'
          }
          // 当前步骤 && 是最新步骤 && 不是最后一步
          return 'process'
        }
        return 'finish'
      } else {
        // 非当前步骤 && 小于最新步骤
        if (stepIndex < this.fixedStepIndex) {
          return 'success'
        } else if (stepIndex === this.fixedStepIndex) {
          // 非当前步骤 && 是最后一步
          if (stepIndex === lastStepIndex) {
            return 'process'
          }
          // 非当前步骤 && 小于最后一步
          return 'process'
        }
        // 非当前步骤 && 大于最新步骤
        return ''
      }
    },
    handleStepClick(stepIndex) {
      this.$emit('change', stepIndex)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-steps .el-step .el-step__head.is-finish .el-step__line .el-step__line-inner {
  border-width: 1px !important;
  width: 100% !important;
}

::v-deep .el-steps .el-step .el-step__head.is-finish .el-step__icon {
  color: #276BEC !important;
  background: none !important;
}

::v-deep .el-steps .el-step .el-step__head.is-success .el-step__line .el-step__line-inner {
  border-width: 1px !important;
  width: 100% !important;
}

// ::v-deep .el-steps .el-step .el-step__head.is-process .el-step__line .el-step__line-inner {
//   border-width: 1px !important;
//   width: 100% !important;
// }
</style>
